import React from 'react';
import { Button } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';

export default function DashboardRefreshButton({
  children = 'Refresh',
  className,
  icon = <ReloadOutlined />,
  loading,
  onClick,
  ...buttonProps
}) {
  return (
    <Button
      className={className}
      icon={icon}
      loading={loading}
      onClick={onClick}
      {...buttonProps}
    >
      {children}
    </Button>
  );
}
